import React, { useState } from "react";
import { login, extractErrorMessage } from "../services/adminApi";

const LoginPage = ({ onLoggedIn }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(username, password);
            onLoggedIn();
        } catch (err) {
            setError(
                extractErrorMessage(err, "Не удалось войти. Попробуйте ещё раз.")
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-screen">
            <form className="admin-login-card" onSubmit={handleSubmit}>
                <h1 className="admin-login-title">Геокарбон · Админка</h1>
                <p className="admin-login-subtitle">
                    Вход только для владельца сайта
                </p>

                <label className="admin-field">
                    <span>Логин</span>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoComplete="username"
                        autoFocus
                        required
                    />
                </label>

                <label className="admin-field">
                    <span>Пароль</span>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                        required
                    />
                </label>

                {error && <p className="admin-error">{error}</p>}

                <button
                    type="submit"
                    className="admin-primary-button"
                    disabled={loading}
                >
                    {loading ? "Входим…" : "Войти"}
                </button>
            </form>
        </div>
    );
};

export default LoginPage;
